// extracted by mini-css-extract-plugin
module.exports = {"tooltipTrigger":"_20cf4b61","wrapper":"_bf5c1abf"};